module.exports = __webpack_public_path__ + "static/media/pg.9fb81100.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pg.svg
// module id = 2186
// module chunks = 0